import updatePrimary from '@api/routes/myvca-api/update-primary-contact';
import updateAddress from '@api/routes/myvca-api/update-primary-address';
import updateEmergency from '@api/routes/myvca-api/update-emergency-contact';
import resetPassword from '@api/routes/myvca-api/send-password-reset';


var VCA = VCA || {};

VCA.AccountPreferences = (function ($) {

    var ui = {};
    let config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    }

    function cacheUI() {
        ui.$tabswrapper = $('.js-myvca-tabs');
        ui.$editBtn = $('.js-edit-info');
        ui.$cancelBtn = $('.js-cancel-edits');
        ui.$submitBtn = $('.js-submit-edits');
        ui.$changePasswordBtn = $('.js-change-password');
        ui.token = $('input[name="__RequestVerificationToken"]').val();
        ui.dataSourcedId = window.datasourceId;
        ui.loader = $('.ajax-loader');
    }

    function init() {
        if ($('.myvca-account-pref').length <= 0) {
            return;
        }
        cacheUI();
        bindEditItem();
        bindCancelItem();
        bindChangePassword();
        bindsubmititem();
    }

    function bindEditItem() {
        ui.$tabswrapper.on('click', '.js-edit-info', function (e) {
            e.preventDefault();
            $(this).hide();
            parent = $(this).closest('.js-myvca-account-box');
            parent.find('.js-myvca-account').hide();
            parent.find('.js-myvca-account-error-message').hide();
            parent.find('.js-myvca-account-contact-form').show();
            parent.find('.js-submit-edits').show();
            parent.find('.js-cancel-edits').show();
        });
    }

    function updateInputAfterCancel(editBtn) {
        let parent = $(editBtn).closest('.myvca-account-box');
        $(parent).find('.form-label-group').each((idx,el) => {
            let originalValue = $(el).find('input.acctpref-hidden-input').val();
            $(el).find('.js-required').val(originalValue);
            $(el).find('.js-required').html(originalValue);
        });
    }

    function removeErrorMessages(cancelBtn) {
        let parent = $(cancelBtn).closest('.myvca-account-box');
        $(parent).find('.form-label-group').each((idx,el) => {
            $(el).removeClass('error');
            $(el).find('input.js-required').removeClass('error');
        });
    }

    function bindCancelItem() {
        ui.$tabswrapper.on('click', '.js-cancel-edits', function (e) {
            e.preventDefault();
            $(this).hide();
            parent = $(this).closest('.js-myvca-account-box');
            parent.find('.js-myvca-account-contact-form').hide();
            updateInputAfterCancel(this);
            removeErrorMessages(this);
            parent.find('.js-submit-edits').hide();
            parent.find('.js-myvca-account').show();
            parent.find('.js-edit-info').show();
        });
    }

    function bindChangePassword() {
        ui.$tabswrapper.on('click', '.js-change-password', function (e) {
            e.preventDefault();
            parent = $(this).closest('.js-myvca-account-box');
            parent.find('.js-myvca-account-error-message').hide();
            sendChangePasswordEmail(parent);
        });
    }

    function bindsubmititem() {
        ui.$tabswrapper.on('click', '.js-submit-edits', function (e) {
            e.preventDefault();
            parent = $(this).closest('.js-myvca-account-box');
            if(!checkform(parent)){
                return;
            }
            else {
                parent.append(ui.loader);
                ui.loader.show();
              if(parent.data('type') == 'primary'){
                updatePrimaryContact(parent);
              }else if(parent.data('type') == 'address'){
                updatePrimaryAddress(parent);

              }else{
                updateEmergencyContact(parent);
              }

            }
        });
    }

    function checkform(parent) {
        var mailFormat = /(^[a-zA-Z0-9_.]+[@]{1}[a-zA-Z0-9\-]+[\.][a-zA-Z]+$)/;
        var phoneReg = /^(?:((\s?\(\d{3}\)\s?|\s?\d{3}\s?)\-?\d{3}\s?\-?\d{4}$))/;
        var textReg = /^[a-zA-Z0-9 -]{2,60}$/;
        var zipReg = /^(\d{5})(?:-?(\d{4}))?$/;

        let valid = true

        parent.find('input').each(function(index) {
            let el = $(this);
            var elmId = el.attr("name");
            if (el.hasClass('js-required')) {
                if (elmId == 'phone') {
                    let phone = el.val();
                    if (!phoneReg.test(phone)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                    }
                } else if (elmId == 'email') {
                    let email = el.val();
                    if (!mailFormat.test(email)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                    }
                } else if (elmId == 'firstName' || elmId == 'lastName') {
                    let inputText = el.val();
                    if (!textReg.test(inputText)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                    }
                }else if (elmId == 'zip') {
                    let inputZip = el.val();
                    if (!zipReg.test(inputZip)) {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                    }
                } else {
                    if (el.val() == '') {
                        el.addClass('error');
                        el.closest('.form-label-group').addClass('error');
                        valid = false;
                    } else {
                        el.removeClass('error');
                        el.closest('.form-label-group').removeClass('error');
                    }
                }
            }
        });
        parent.find('select').each(function(index) {
            let el = $(this);
            if (el.hasClass('js-required')) {
                if (el.val() == '' || el.val() == null) {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
        });

        return valid;
    }

    function updateInfo(parent) {
        let updateItems = parent.find('.js-myvca-account');
        parent.find('input').each(function(index) {
            let elValue = $(this).val();
            let elName = $(this).data('item');
            updateItems.find('[data-item="' + elName +'"]').text(elValue);
        });
        parent.find('select').each(function(index) {
            let elValue = $(this).val();
            let elName = $(this).data('item');
            updateItems.find('[data-item="' + elName +'"]').text(elValue);
        });
        parent.find('.js-myvca-account-contact-form').hide();
        parent.find('.js-cancel-edits').hide();
        parent.find('.js-submit-edits').hide();
        parent.find('.js-myvca-account').show();
        parent.find('.js-edit-info').show();
        ui.loader.hide();
    }

    function failedUpdate(parent) {
        parent.find('.js-myvca-account-contact-form').hide();
        parent.find('.js-submit-edits').hide();
        parent.find('.js-cancel-edits').hide();
        parent.find('.js-myvca-account').show();
        parent.find('.js-edit-info').show();
        parent.find('.js-myvca-account-error-message').show();
        ui.loader.hide();
    }

    async function sendChangePasswordEmail(parent) {
        let params = {
            '__RequestVerificationToken': ui.token,
            'datasourceId': ui.dataSourcedId
        };
        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');

        params = searchParams(params);
        //console.log(params);

        parent.append(ui.loader);
        ui.loader.show();

        const { success, data, error }  = await resetPassword.post(params, config);

        //console.log(data);

        if(!success || !data){
            console.log('failed', error);
            parent.find('.js-myvca-account-error-message').show();
            ui.loader.hide();
		    return;
        }
        //console.log(params);
        //console.log(success);
        ui.loader.hide();
        parent.find('.js-myvca-account-contact-form').show();

    }

    async function updatePrimaryContact(parent) {
        let params = getPrarms(parent);

       // console.log('params', params);

        const { success, data, error }  = await updatePrimary.post(params, config);

       // console.log(data);

        if(!success || !data){
            console.log('failed', error);
            failedUpdate(parent);
		    return;
        }
       // console.log(params);
      //  console.log(success);
        updateInfo(parent);

    }

    async function updatePrimaryAddress(parent) {
        let params = getPrarms(parent);

        const { success, data, error }  = await updateAddress.post(params, config);

       // console.log(data);

        if(!success || !data){
            console.log('failed', error);
            failedUpdate(parent);
		    return;
        }
     //   console.log(params);
      //  console.log(success);
        updateInfo(parent);
    }

    async function updateEmergencyContact(parent) {
        let params = getPrarms(parent);

        const { success, data, error }  = await updateEmergency.post(params, config);

      //  console.log(data);

        if(!success || !data){
            console.log('failed', error);
            failedUpdate(parent);
		    return;
        }
      //  console.log(params);
      //  console.log(success);
        updateInfo(parent);
    }

    function getPrarms(parent) {
        let params = {
            '__RequestVerificationToken': ui.token
        };
        parent.find('input').each(function (index) {
            let elValue = $(this).val();
            let elName = $(this).attr('name');
            if(elName == 'phone') {
                elValue = elValue.replace(/[()-\s]/g, '');
            }
            params[elName] = elValue;
        });
        parent.find('select').each(function (index) {
            let elValue = $(this).val();
            let elName = $(this).attr('name');
            params[elName] = elValue;
        });
        const searchParams = params => Object.keys(params).map((key) => {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
                }).join('&');

        params = searchParams(params)

        return params;
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.AccountPreferences.init();
});